import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { ErrorState, LinkButton } from '@/components/ui';
import { Wordmark } from '@/components/brand/Logo';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }) => (
    <main className="auth-wrap">
      <div className="auth-form">
        <ErrorState error={error} onRetry={reset} />
      </div>
    </main>
  ),
});

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
    </>
  );
}

function NotFound() {
  return (
    <main className="auth-wrap">
      <title>Not found · Eryce</title>
      <div className="auth-form">
        <span className="wordmark">
          <Wordmark />
        </span>
        <div className="stack-sm">
          <h1>Page not found</h1>
          <p className="muted">Address not found or not accessible.</p>
        </div>
        <LinkButton to="/app/conversations" variant="primary" className="btn-block">
          Go to Conversations
        </LinkButton>
      </div>
    </main>
  );
}
